<script setup>
import { getCurrentInstance, ref } from 'vue'
import PmSummaryIndex from './Index.vue'
import PmSummaryForm from './Form.vue'

const indexRef = ref(null)
const breakpoints = getCurrentInstance().proxy.$vuetify.breakpoint

const onSuccessHandler = () => {
  indexRef.value?.getList?.()
}
</script>

<style lang="sass" scoped>
.pm-summary-template
  display: flex
  flex-direction: column
  gap: 10px
  .layout
    display: flex
    gap: 10px
    &.mobile
      flex-direction: column
  .box-bubble
    padding: 10px
    border-radius: 10px
    border: 1px solid #cfcdcd
  .form-col
    width: 420px
    flex-shrink: 0
  .index-col
    flex: 1
    min-width: 0
</style>

<template>
  <div class="pm-summary-template">
    <div :class="`layout ${breakpoints.mobile ? 'mobile' : ''}`">
      <div class="form-col box-bubble">
        <PmSummaryForm @on-success="onSuccessHandler" />
      </div>
      <div class="index-col box-bubble">
        <PmSummaryIndex ref="indexRef" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PmSummaryTemplate',
}
</script>
